import CobranzaDelete from './CobranzaDelete'
export {CobranzaDelete}
export default CobranzaDelete
